export default {
  REJECT: 'Reject',
  ACCEPT: 'Accept',
  NO_RESPOND: 'No Respond'
}
